module.exports = __webpack_public_path__ + "static/img/shop_img03.e477b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/integralshop/shop_img03.png
// module id = WULN
// module chunks = 174